import { getPath } from '@/router/common'

const baseUrl = {
  title: '蓝桥广达打印控件',
  path: 'zyDownload'
}

export default [
  {
    path: getPath('zyDownloadDetails', baseUrl),
    name: 'zyDownloadDetails',
    component: () => import(/* webpackChunkName: "zyDownloadDetails" */ '@/views/zyDownload/zyDownloadDetails/index.vue'),
    meta: {
      title: '蓝桥广达打印控件'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'zyDownload_Index',
    component: () => import(/* webpackChunkName: "zyDownload_Index" */ '@/views/zyDownload/index/index.vue'),
    meta: {
      title: '资源大本营'
    }
  },
  {
    path: getPath('ProblemsLibrary', baseUrl),
    name: 'zyDownload_ProblemsLibrary',
    component: () => import(/* webpackChunkName: "zyDownload_ProblemsLibrary" */ '@/views/zyDownload/problemsLibrary/index.vue'),
    meta: {
      title: '常见问题'
    }
  },
  {
    path: getPath('TextCourse', baseUrl),
    name: 'zyDownload_TextCourse',
    component: () => import(/* webpackChunkName: "zyDownload_TextCourse" */ '@/views/zyDownload/textCourse/index.vue'),
    meta: {
      title: '图文教程'
    }
  },
  {
    path: getPath('ProblemsDetails', baseUrl),
    name: 'zyDownload_ProblemsDetails',
    component: () => import(/* webpackChunkName: "zyDownload_TextCourse" */ '@/views/zyDownload/problemsDetails/index.vue'),
    meta: {
      title: '教程详情'
    }
  },
  {
    path: getPath('VideoTutorial', baseUrl),
    name: 'zyDownload_VideoTutorial',
    component: () => import(/* webpackChunkName: "zyDownload_VideoTutorial" */ '@/views/zyDownload/videoTutorial/index.vue'),
    meta: {
      title: '视频教程'
    }
  },
  {
    path: getPath('NewUSerGuideTutorial', baseUrl),
    name: 'zyDownload_NewUSerGuideTutorial',
    component: () => import(/* webpackChunkName: "zyDownload_VideoTutorial" */ '@/views/zyDownload/newUSerGuideTutorial/index.vue'),
    meta: {
      title: '新手指南'
    }
  },
]
